import { logoutUser } from '../../util';

export const ExtensionSignOut = (): null => {
  logoutUser();
  return null;
}